import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "../../api/client";

export const useSubmitReport = () =>
  useMutation({
    mutationFn: ({ reportedAthleteId, reportedScoutId, category, description, context }) =>
      apiFetch("/reports", {
        method: "POST",
        body: {
          reported_athlete_id: reportedAthleteId || null,
          reported_scout_id: reportedScoutId || null,
          category,
          description: description || null,
          context,
        },
      }),
  });
